import { num } from "./decimal";

const usd0 = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
const usd2 = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 });
const int = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

export function money(v: string | number | null | undefined, opts: { cents?: boolean } = {}): string {
  const n = num(v);
  if (n === null) return "";
  return opts.cents ? usd2.format(n) : usd0.format(n);
}

/** $1.25M / $850k / $8,250 */
export function moneyCompact(v: string | number | null | undefined): string {
  const n = num(v);
  if (n === null) return "";
  const a = Math.abs(n);
  const sign = n < 0 ? "−" : "";
  if (a >= 1_000_000) return `${sign}$${trim(a / 1_000_000, 2)}M`;
  if (a >= 10_000) return `${sign}$${trim(a / 1_000, 1)}k`;
  return `${sign}${usd0.format(a)}`;
}

function trim(x: number, dp: number): string {
  return x.toFixed(dp).replace(/\.?0+$/, "");
}

export function amountPlain(v: string | number | null | undefined): string {
  const n = num(v);
  return n === null ? "" : int.format(n);
}

export function price3(v: string | number | null | undefined): string {
  const n = num(v);
  return n === null ? "" : n.toFixed(3);
}

export function pts3(v: string | number | null | undefined): string {
  const n = num(v);
  return n === null ? "" : n.toFixed(3);
}

export function pct1(v: number | null): string {
  return v === null || !Number.isFinite(v) ? "—" : `${Math.round(v * 10) / 10}%`.replace(/\.0%$/, "%");
}

export function signedMoney(n: number): string {
  if (n === 0) return "$0";
  return `${n > 0 ? "+" : "−"}${usd0.format(Math.abs(n))}`;
}

export function initials(name: string | null | undefined): string {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? "") + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
}
